import { Scale, Eye, Cpu, UserX, Satellite, AlertTriangle, Shield, Database, Lock, CreditCard, FileText, Ban } from 'lucide-react';

export const TERMS_VERSION = '2026-04-v2';

export const PART_HEADERS = [
  { id: 'terms', label: "Partie 1 — Conditions d'utilisation" },
  { id: 'privacy', label: 'Partie 2 — Politique de confidentialite' },
  { id: 'payment', label: 'Partie 3 — Paiement et abonnements' },
];

export const SECTIONS = [
  {
    part: 0,
    id: 'legal-use',
    icon: Scale,
    title: "1. Utilisation legale obligatoire",
    critical: true,
    content: [
      { type: 'p', text: "L'utilisateur s'engage a utiliser OBGH Territoire Pro exclusivement dans le respect des lois federales et provinciales du Canada et du Quebec, incluant sans s'y limiter :" },
      { type: 'ul', items: [
        "La Loi sur la conservation et la mise en valeur de la faune (LCMVF)",
        "Les reglements sur les periodes, zones et quotas de chasse",
        "Les reglements sur les armes a feu et la securite",
        "Les reglements municipaux et les droits de propriete prives",
      ]},
      { type: 'warning', text: "Toute utilisation de l'application a des fins de braconnage, de chasse hors-saison, de chasse sans permis valide, ou toute autre activite illegale est STRICTEMENT INTERDITE." },
      { type: 'p', text: "OBGH Territoire Pro n'encourage, ne facilite et ne cautionne aucune activite illegale. L'utilisateur est le seul responsable de verifier que ses activites sont conformes aux lois en vigueur." },
    ],
  },
  {
    part: 0,
    id: 'thermal',
    icon: Eye,
    title: "2. Fonctionnalites de vision thermique",
    critical: true,
    content: [
      { type: 'p', text: "Les fonctionnalites de vision thermique et de detection de signatures de chaleur sont fournies a titre d'aide a la recherche de gibier blesse uniquement." },
      { type: 'warning', text: "Il est STRICTEMENT INTERDIT d'utiliser la vision thermique pour :" },
      { type: 'ul-danger', items: [
        "Localiser du gibier vivant a des fins de braconnage ou chasse illegale",
        "Chasser la nuit ou pendant les heures non-legales",
        "Surveiller ou espionner des personnes sans leur consentement",
        "Toute activite contraire aux lois sur la vie privee et la surveillance",
      ]},
      { type: 'p', text: "La vision thermique est un outil de recuperation destine a aider les chasseurs a retrouver du gibier blesse apres un tir legal, conformement aux obligations ethiques du chasseur. Les temperatures et classifications animales affichees sont des estimations algorithmiques et ne constituent pas des mesures scientifiques precises." },
    ],
  },
  {
    part: 0,
    id: 'ai-ip',
    icon: Cpu,
    title: "3. Propriete intellectuelle — Outils IA exclusifs",
    critical: true,
    content: [
      { type: 'p', text: "Les outils d'intelligence artificielle de OBGH Territoire Pro, incluant sans s'y limiter l'IA Chien de Sang, la vision thermique algorithmique, le systeme de prediction de trajectoire, la detection de signatures animales, l'analyse thermique par satellite et tous les algorithmes de traitement d'images sont la propriete exclusive et protegee de OBGH inc." },
      { type: 'warning', text: "Ces technologies sont EXCLUSIVES, PROTEGEES et NON REPRODUCTIBLES. Il est STRICTEMENT INTERDIT de :" },
      { type: 'ul-danger', items: [
        "Copier, reproduire, imiter ou recreer un systeme similaire base sur les technologies de OBGH",
        "Faire de l'ingenierie inverse (reverse engineering) sur les algorithmes IA de l'application",
        "Extraire, collecter ou scraper les resultats, donnees ou analyses generes par l'IA",
        "Utiliser les resultats de l'IA a des fins commerciales, de revente ou de redistribution",
        "Entrainer, alimenter ou ameliorer toute autre intelligence artificielle, modele de machine learning ou systeme concurrent avec les resultats, donnees ou analyses produits par OBGH",
        "Partager, publier ou diffuser les algorithmes, methodes ou resultats d'analyse a des fins de reproduction technologique",
      ]},
      { type: 'p', text: "Toute violation de ces clauses de propriete intellectuelle expose l'utilisateur a des poursuites judiciaires en vertu des lois canadiennes et internationales sur la propriete intellectuelle, les brevets et les droits d'auteur." },
    ],
  },
  {
    part: 0,
    id: 'ai-abuse',
    icon: UserX,
    title: "4. Utilisation abusive de l'IA — Suspension de compte",
    critical: true,
    content: [
      { type: 'warning', text: "Toute utilisation abusive des outils d'intelligence artificielle de OBGH Territoire Pro entrainera la SUSPENSION IMMEDIATE et PERMANENTE du compte de l'utilisateur, sans remboursement." },
      { type: 'p', text: "Sont considerees comme utilisations abusives :" },
      { type: 'ul-danger', items: [
        "L'utilisation automatisee ou par scripts/bots des fonctionnalites IA",
        "L'extraction massive de donnees ou de resultats d'analyse",
        "L'utilisation de l'IA pour entrainer des systemes concurrents",
        "Le depassement intentionnel et repete des quotas d'utilisation",
        "L'utilisation de l'application pour des activites de braconnage ou illegales",
        "Le partage de compte pour contourner les limites d'utilisation",
      ]},
      { type: 'p', text: "OBGH Territoire Pro se reserve le droit de surveiller les patterns d'utilisation de l'IA et de suspendre tout compte presentant un comportement anormal ou abusif, sans preavis ni recours." },
    ],
  },
  {
    part: 0,
    id: 'satellite',
    icon: Satellite,
    title: "5. Donnees satellitaires et IA",
    critical: false,
    content: [
      { type: 'p', text: "Les donnees affichees dans l'application, incluant les images satellites, les analyses thermiques et les predictions de l'intelligence artificielle, sont fournies a titre indicatif seulement. OBGH Territoire Pro ne garantit pas l'exactitude, la precision ou la fiabilite des analyses IA. L'utilisateur demeure entierement responsable de ses decisions et actions sur le terrain." },
    ],
  },
  {
    part: 0,
    id: 'liability',
    icon: AlertTriangle,
    title: "6. Limitation de responsabilite",
    critical: true,
    content: [
      { type: 'p', text: 'OBGH Territoire Pro est fourni "tel quel", sans garantie d\'aucune sorte.' },
      { type: 'warning', text: "En aucun cas OBGH Territoire Pro, ses dirigeants, employes, developpeurs ou partenaires ne pourront etre tenus responsables de tout dommage direct, indirect, accessoire, special ou consecutif decoulant de l'utilisation de l'application, incluant :" },
      { type: 'ul-danger', items: [
        "Blessures corporelles ou deces resultant de l'utilisation de l'application",
        "Poursuites legales liees a des activites illegales de l'utilisateur",
        "Perte de donnees, d'equipement ou de materiel",
        "Dommages materiels ou financiers de toute nature",
      ]},
      { type: 'p', text: "L'utilisateur reconnait que la chasse comporte des risques inherents et utilise l'application a ses propres risques et perils." },
    ],
  },
  {
    part: 0,
    id: 'ip',
    icon: Shield,
    title: "7. Propriete intellectuelle globale",
    critical: false,
    content: [
      { type: 'p', text: "L'application OBGH Territoire Pro, son code source, son design, son interface utilisateur, ses algorithmes d'IA, ses modeles de detection, ses bases de donnees, sa marque, son logo et l'ensemble de son contenu sont la propriete exclusive de OBGH inc." },
      { type: 'warning', text: "Toute reproduction, distribution, modification, decompilation, desassemblage ou creation d'oeuvres derivees non autorisee est strictement interdite et passible de poursuites." },
      { type: 'p', text: "Les donnees tierces (images satellites, donnees meteo, donnees geospatiales) restent la propriete de leurs fournisseurs respectifs." },
    ],
  },
  {
    part: 1,
    id: 'data-collection',
    icon: Database,
    title: "8. Collecte de donnees personnelles",
    critical: false,
    content: [
      { type: 'p', text: "OBGH Territoire Pro collecte les donnees suivantes dans le cadre de la fourniture de ses services :" },
      { type: 'ul', items: [
        "Donnees d'identification : adresse email, nom d'utilisateur, mot de passe (hache)",
        "Donnees de localisation : coordonnees GPS (avec consentement explicite de l'utilisateur)",
        "Donnees de contenu : photos uploadees pour l'analyse IA, marqueurs de pistage, notes de chasse",
        "Donnees d'utilisation : historique de sessions, statistiques d'utilisation, preferences",
        "Donnees de paiement : traitees securement par Stripe inc. — OBGH ne stocke jamais les numeros de carte",
      ]},
    ],
  },
  {
    part: 1,
    id: 'data-use',
    icon: Lock,
    title: "9. Utilisation et protection des donnees",
    critical: false,
    content: [
      { type: 'p', text: "Vos donnees personnelles sont utilisees pour fournir et ameliorer les services, analyser les images, gerer votre compte et vous envoyer des communications liees au service." },
      { type: 'warning', text: "Nous ne vendons JAMAIS vos donnees personnelles a des tiers." },
      { type: 'p', text: "Securite: mots de passe haches bcrypt, sessions HttpOnly + Secure, HTTPS/TLS, MongoDB Atlas securise. Droit de suppression: contactez support@obgh.ca (30 jours). Conservation: tant que le compte est actif." },
    ],
  },
  {
    part: 2,
    id: 'payment',
    icon: CreditCard,
    title: "10. Forfaits, tarification et paiement",
    critical: false,
    content: [
      { type: 'p', text: "OBGH Territoire Pro offre 4 forfaits: Gratuit (0$, 3 sites), Pro (29.99$/an, 10 sites), Elite (39.99$/an, illimite + SOS), Ultra (56.99$/an ou 6.99$/mois, tout inclus, 2 recherches IA Chien de Sang incluses puis 9.99$/recherche) — offre de lancement. Pendant l'offre de lancement « Ultra gratuit », l'acces Ultra est offert sans carte de credit (1 recherche IA incluse) et peut prendre fin sur decision d'OBGH avec un preavis de 3 jours, apres quoi le compte revient au forfait Gratuit sauf abonnement. Abonnements via Stripe." },
    ],
  },
  {
    part: 2,
    id: 'refunds',
    icon: FileText,
    title: "11. Remboursements et annulation",
    critical: false,
    content: [
      { type: 'p', text: "Remboursements disponibles 14 jours apres l'achat initial. Annulation a tout moment, acces jusqu'a expiration. Recherches IA pay-per-use non remboursables une fois executees." },
    ],
  },
  {
    part: 2,
    id: 'termination',
    icon: Ban,
    title: "12. Resiliation et suspension",
    critical: true,
    content: [
      { type: 'p', text: "OBGH Territoire Pro se reserve le droit de suspendre ou resilier immediatement et sans preavis tout compte en cas de :" },
      { type: 'ul-danger', items: [
        "Violation des presentes conditions d'utilisation",
        "Utilisation abusive des outils d'intelligence artificielle",
        "Braconnage ou activite de chasse illegale",
        "Tentative de copier, reproduire ou extraire les technologies IA",
        "Fraude ou utilisation de moyens de paiement frauduleux",
        "Partage de compte ou contournement des limites d'utilisation",
      ]},
      { type: 'warning', text: "En cas de suspension pour violation, aucun remboursement ne sera accorde." },
    ],
  },
];
